<template>
  <ol class="list-unstyled calendar-week-list">
    <MonthSection
      v-for="(day, index) of $t(`calendar.header.daysOfWeek`)"
      :key="index"
      :day="day"
      :rowType="'weekHeader'"
    />
    <WeekSection v-for="(day, index) of week" :key="index + 7" :day="day" />
  </ol>
</template>

<script>
import MonthSection from '@/components/Calendar/MonthSection'
import WeekSection from '@/components/Calendar/WeekSection'

export default {
  props: {
    week: Array,
  },
  components: {
    MonthSection,
    WeekSection,
  },
}
</script>

<style lang="scss">
.calendar-week-list {
  margin: 2.46666rem 0;
  @media (max-width: 768px) {
    margin: 0;
  }
}
</style>
